<!-- Selected member chips -->
<div class="flex flex-wrap gap-1.5 mb-2" *ngIf="selectedMembers.length > 0">
  <span
    *ngFor="let m of selectedMembers"
    class="inline-flex items-center gap-1 rounded-full bg-violet-100 px-2.5 py-1 text-xs font-medium text-violet-800"
  >
    {{ displayName(m) }}
    <button
      *ngIf="!readOnly"
      type="button"
      (click)="remove(m.userId)"
      class="ml-0.5 flex h-3.5 w-3.5 items-center justify-center rounded-full text-violet-500 hover:bg-violet-200 hover:text-violet-900 focus:outline-none"
      [attr.aria-label]="'Remove ' + displayName(m)"
    >
      <lucide-icon name="x" [size]="10" [strokeWidth]="2.5"></lucide-icon>
    </button>
  </span>
</div>

<!-- Empty state (read-only) -->
<p *ngIf="selectedMembers.length === 0 && readOnly" class="text-xs text-slate-400 italic">No recipients selected.</p>

<!-- Search input + dropdown (edit mode only) -->
<div class="relative" *ngIf="!readOnly">
  <div class="relative">
    <lucide-icon
      name="search"
      [size]="13"
      class="pointer-events-none absolute top-1/2 -translate-y-1/2 text-slate-400" style="left: 0.30em"
      [strokeWidth]="2"
    ></lucide-icon>
    <input
      type="text"
      [(ngModel)]="searchQuery"
      [ngModelOptions]="{standalone: true}"
      (focus)="onSearchFocus()"
      (input)="openDropdown()"
      (blur)="closeDropdown()"
      placeholder="{{ members.length === 0 ? 'No members available' : 'Add a member…' }}"
      [disabled]="members.length === 0"
      class="w-full rounded-md border border-slate-200 bg-white py-2 pl-5 pr-3 text-sm text-slate-900 placeholder-slate-400 focus:border-violet-400 focus:outline-none focus:ring-1 focus:ring-violet-300 disabled:cursor-not-allowed disabled:bg-slate-50"
    />
  </div>

  <!-- Dropdown list — mousedown fires before blur so selection is captured first -->
  <div
    *ngIf="dropdownOpen && availableMembers.length > 0"
    class="absolute z-20 mt-1 w-full overflow-hidden rounded-lg border border-slate-200 bg-white shadow-lg"
  >
    <ul class="max-h-48 overflow-y-auto py-1">
      <li
        *ngFor="let m of availableMembers"
        (mousedown)="add(m)"
        class="flex cursor-pointer items-center gap-3 px-3 py-2 hover:bg-violet-50"
      >
        <div class="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-violet-100 text-[11px] font-semibold text-violet-700">
          {{ (m.givenName?.[0] ?? m.email[0] ?? '?').toUpperCase() }}
        </div>
        <div class="min-w-0">
          <p class="truncate text-sm font-medium text-slate-900">{{ displayName(m) }}</p>
          <p class="truncate text-xs text-slate-400">{{ m.email }}</p>
        </div>
      </li>
    </ul>
  </div>

  <!-- No results message -->
  <div
    *ngIf="dropdownOpen && availableMembers.length === 0 && searchQuery"
    class="absolute z-20 mt-1 w-full rounded-lg border border-slate-200 bg-white px-3 py-3 shadow-lg"
  >
    <p class="text-xs text-slate-400">No matching members found.</p>
  </div>
</div>
